module.exports = __webpack_public_path__ + "static/media/title-coffee.5050a209.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/title-coffee.png
// module id = 485
// module chunks = 0